import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57475652"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "course-attendance-container" }
const _hoisted_2 = { class: "period-config-section" }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "期數日期管理", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 新增期數 ")
const _hoisted_6 = { class: "config-cards" }
const _hoisted_7 = { class: "config-header" }
const _hoisted_8 = { class: "config-form" }
const _hoisted_9 = { class: "form-row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-label" }, "開始日期：", -1))
const _hoisted_11 = { class: "form-row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-label" }, "課程天數：", -1))
const _hoisted_13 = { class: "form-row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-label" }, "簽到上限：", -1))
const _hoisted_15 = { class: "periods-overview" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "課程期數總覽", -1))
const _hoisted_17 = { class: "periods-grid" }
const _hoisted_18 = { class: "period-header" }
const _hoisted_19 = { class: "period-info" }
const _hoisted_20 = { class: "period-dates" }
const _hoisted_21 = {
  key: 0,
  class: "extension-note"
}
const _hoisted_22 = { class: "period-stats" }
const _hoisted_23 = { class: "attendance-cell" }
const _hoisted_24 = {
  key: 0,
  class: "progress-cell"
}
const _hoisted_25 = { class: "progress-text" }
const _hoisted_26 = {
  key: 1,
  style: {"color":"#909399"}
}
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" 編輯 ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 刪除 ")
const _hoisted_29 = { class: "dialog-footer" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("保存")

import { computed, reactive, ref, watch } from 'vue';
import { ElTable, ElTableColumn, ElTag, ElButton, ElIcon, ElAlert, ElProgress, ElDatePicker, ElInputNumber, ElMessage, ElMessageBox } from 'element-plus';
import { EditPen, Delete, Plus } from '@element-plus/icons-vue';
import API from '@/apis/TPSAPI';

// 定義介面
interface AttendanceRecord {
  id: number;
  attendanceDate: string;
  attendanceType: number; // 0: 曠課, 1: 出席, 2: 請假
  isTrigger: boolean;
  periodNumber: number; // 期數
  periodProgress: string; // 期內進度 "1/4", "2/4" 等
  periodAttendanceIndex: number; // 期內出席/曠課索引
}

interface Period {
  periodNumber: number;
  startDate: string;
  endDate: string;
  attendanceCount: number; // 出席+曠課次數
  leaveCount: number;
  remainingCount: number;
  hasLeaveExtension: boolean; // 是否因請假延期
  status: 'active' | 'completed' | 'upcoming';
}

// Props 定義
interface Props {
  visible: boolean;
  studentpermissionId?: number | null;
}

interface PeriodConfig {
  periodNumber: number;
  startDate: string;
  totalDays: number;
  maxAttendanceCount: number;
  maxLeaveCount: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DialogAttendance',
  props: {
    visible: { type: Boolean },
    studentpermissionId: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: boolean): void;
  edit: [row: AttendanceRecord];
  delete: [row: AttendanceRecord];
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  visible: boolean;
  studentpermissionId?: number | null;
}



// Emits 定義 - 使用函數簽章語法


// 更新值的方法
const updateValue = (value: boolean) => {
  emit('update:modelValue', value);
};

// 處理對話框變化
const handleDialogChange = (value: boolean) => {
  if (!value) {
    emit('update:modelValue', false);
  }
};

// 關閉對話框
const closeDialog = () => {
  emit('update:modelValue', false);
};

// 保存並關閉
const saveAndClose = () => {
  // 這裡可以執行保存邏輯
  emit('update:modelValue', false);
};

// 出席類型映射
const attendanceTypeMap = {
  0: '曠課',
  1: '出席', 
  2: '請假'
} as const;

// 標籤顏色映射
const attendanceTagTypeMap = {
  0: 'danger',   // 曠課 - 紅色
  1: 'success',  // 出席 - 綠色
  2: 'warning'   // 請假 - 黃色
} as const;

// 模擬10筆記錄資料（調整為更清楚的示例）
const rawAttendanceData = ref([
  // { id: 1, attendanceDate: "2025-07-01", attendanceType: 1, isTrigger: true },  // 第1期-第1次
  // { id: 2, attendanceDate: "2025-07-03", attendanceType: 1, isTrigger: false }, // 第1期-第2次
  // { id: 3, attendanceDate: "2025-07-05", attendanceType: 0, isTrigger: true },  // 第1期-第3次
  // { id: 4, attendanceDate: "2025-07-08", attendanceType: 2, isTrigger: false }, // 第1期-請假(延期7天)
  // { id: 5, attendanceDate: "2025-07-12", attendanceType: 1, isTrigger: false }, // 第1期-第4次(期滿)
  // { id: 6, attendanceDate: "2025-08-05", attendanceType: 1, isTrigger: true },  // 第2期-第1次
  // { id: 7, attendanceDate: "2025-08-08", attendanceType: 0, isTrigger: false }, // 第2期-第2次
  // { id: 8, attendanceDate: "2025-08-10", attendanceType: 1, isTrigger: true },  // 第2期-第3次
  // { id: 9, attendanceDate: "2025-08-15", attendanceType: 1, isTrigger: false }, // 第2期-第4次(期滿)
  // { id: 10, attendanceDate: "2025-09-03", attendanceType: 1, isTrigger: true } // 第3期-第1次
]);

// 定義期數配置介面
const today = new Date().toISOString().split('T')[0];

// 每期的獨立配置（可以從後端獲取或手動設定）
const periodConfigs = ref<PeriodConfig[]>([
  {
    periodNumber: 1,
    startDate: '2025-07-04',
    totalDays: 28,
    maxAttendanceCount: 4,
    maxLeaveCount: 1
  },
  // {
  //   periodNumber: 2,
  //   startDate: today, // 獨立設定的開始日期
  //   totalDays: 28,
  //   maxAttendanceCount: 4,
  //   maxLeaveCount: 1
  // }
]);

// 計算分期資料
const periods = computed((): Period[] => {
  const periodList: Period[] = [];
  
  // 為每個配置的期數計算實際資料
  periodConfigs.value.forEach(config => {
    const periodStartDate = new Date(config.startDate);
    let periodEndDate = new Date(periodStartDate.getTime() + config.totalDays * 24 * 60 * 60 * 1000);
    
    // 找到屬於此期的記錄
    const periodRecords = rawAttendanceData.value.filter(record => {
      const recordDate = new Date(record.attendanceDate);
      return recordDate >= periodStartDate && recordDate <= periodEndDate;
    });
    
    let attendanceCount = 0; // 出席+曠課的總數
    let leaveCount = 0;
    let hasLeaveExtension = false;
    
    // 按日期排序處理記錄
    periodRecords.sort((a, b) => new Date(a.attendanceDate).getTime() - new Date(b.attendanceDate).getTime());
    
    periodRecords.forEach(record => {
      if (record.attendanceType === 2) { 
        // 請假：不計入4次限制，但延期7天
        if (leaveCount < config.maxLeaveCount) {
          leaveCount++;
          if (!hasLeaveExtension) {
            hasLeaveExtension = true;
            // 延期7天
            periodEndDate = new Date(periodEndDate.getTime() + 7 * 24 * 60 * 60 * 1000);
          }
        }
      } else {
        // 出席或曠課：計入4次限制
        if (attendanceCount < config.maxAttendanceCount) {
          attendanceCount++;
        }
      }
    });
    
    // 如果有記錄屬於此期，或者是第一期，就加入期數列表
    if (periodRecords.length > 0 || config.periodNumber === 1) {
      periodList.push({
        periodNumber: config.periodNumber,
        startDate: config.startDate,
        endDate: periodEndDate.toISOString().split('T')[0],
        attendanceCount,
        leaveCount,
        remainingCount: Math.max(0, config.maxAttendanceCount - attendanceCount),
        hasLeaveExtension,
        status: attendanceCount >= config.maxAttendanceCount ? 'completed' : 
                periodRecords.length > 0 ? 'active' : 'upcoming'
      });
    }
  });
  
  return periodList.sort((a, b) => a.periodNumber - b.periodNumber);
});

// 計算帶有期數資訊的出席記錄
const attendanceRecords = computed((): AttendanceRecord[] => {
  const records: AttendanceRecord[] = [];
  
  // 為每筆記錄分配到對應的期數
  rawAttendanceData.value.forEach(record => {
    const recordDate = new Date(record.attendanceDate);
    
    // 找到記錄所屬的期數
    for (const period of periods.value) {
      const periodStartDate = new Date(period.startDate);
      const periodEndDate = new Date(period.endDate);
      
      if (recordDate >= periodStartDate && recordDate <= periodEndDate) {
        // 計算期內進度
        const periodRecords = rawAttendanceData.value.filter(r => {
          const rDate = new Date(r.attendanceDate);
          return rDate >= periodStartDate && 
                 rDate <= recordDate && 
                 r.attendanceType !== 2; // 不包含請假
        }).sort((a, b) => new Date(a.attendanceDate).getTime() - new Date(b.attendanceDate).getTime());
        
        const periodAttendanceIndex = record.attendanceType === 2 ? 0 : 
          periodRecords.findIndex(r => r.id === record.id) + 1;
        
        records.push({
          ...record,
          periodNumber: period.periodNumber,
          periodProgress: record.attendanceType === 2 ? '請假' : `${periodAttendanceIndex}/4`,
          periodAttendanceIndex: periodAttendanceIndex
        });
        break; // 找到對應期數就跳出
      }
    }
  });
  
  return records.sort((a, b) => new Date(a.attendanceDate).getTime() - new Date(b.attendanceDate).getTime());
});

// 當前期數警告
const currentPeriodWarning = computed(() => {
  const activePeriod = periods.value.find(p => p.status === 'active');
  if (!activePeriod) return null;
  
  if (activePeriod.remainingCount === 0) {
    return {
      title: '期數已滿',
      type: 'error' as const,
      description: `第${activePeriod.periodNumber}期已達到4次簽到限制，將進入下一期！`
    };
  }
  
  if (activePeriod.remainingCount === 1) {
    return {
      title: '繳費提醒',
      type: 'warning' as const,
      description: `第${activePeriod.periodNumber}期僅剩1次簽到機會，請盡快續費！`
    };
  }
  
  return null;
});

// 方法
const getAttendanceTypeText = (type: number): string => {
  return attendanceTypeMap[type as keyof typeof attendanceTypeMap] || '未知';
};

const getAttendanceTagType = (type: number): string => {
  return attendanceTagTypeMap[type as keyof typeof attendanceTagTypeMap] || 'info';
};

const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return `${date.getMonth() + 1}/${date.getDate()}`;
};

const getPeriodCardClass = (period: Period): string => {
  return `period-${period.status}`;
};

const getPeriodStatusType = (period: Period): string => {
  switch (period.status) {
    case 'active': return 'primary';
    case 'completed': return 'success';
    case 'upcoming': return 'info';
    default: return 'info';
  }
};

const getPeriodStatusText = (period: Period): string => {
  switch (period.status) {
    case 'active': return '進行中';
    case 'completed': return '已完成';
    case 'upcoming': return '未開始';
    default: return '未知';
  }
};

const getPeriodTagType = (periodNumber: number): string => {
  const period = periods.value.find(p => p.periodNumber === periodNumber);
  return getPeriodStatusType(period!);
};

const getProgressColor = (index: number): string => {
  if (index >= 4) return '#f56c6c';
  if (index >= 3) return '#e6a23c';
  return '#67c23a';
};

const getPeriodRecordStatusType = (row: AttendanceRecord): string => {
  if (row.periodAttendanceIndex > 4) return 'danger';
  if (row.periodAttendanceIndex === 4) return 'warning';
  return 'success';
};

const getPeriodRecordStatusText = (row: AttendanceRecord): string => {
  if (row.attendanceType === 2) return '請假';
  if (row.periodAttendanceIndex > 4) return '超限';
  if (row.periodAttendanceIndex === 4) return '期滿';
  return '正常';
};

const getRowClassName = ({ row }: { row: AttendanceRecord }): string => {
  const period = periods.value.find(p => p.periodNumber === row.periodNumber);
  return `period-${period?.status || 'unknown'}-row`;
};

// 期數配置管理方法
const addNewPeriod = () => {
  const maxPeriodNumber = Math.max(...periodConfigs.value.map(p => p.periodNumber));
  const lastConfig = periodConfigs.value[periodConfigs.value.length - 1];
  const newStartDate = new Date(lastConfig.startDate);
  newStartDate.setDate(newStartDate.getDate() + lastConfig.totalDays + 1);
  
  periodConfigs.value.push({
    periodNumber: maxPeriodNumber + 1,
    startDate: newStartDate.toISOString().split('T')[0],
    totalDays: 28,
    maxAttendanceCount: 4,
    maxLeaveCount: 1
  });
};

const removePeriod = (periodNumber: number) => {
  if (periodNumber === 1) return; // 不能刪除第一期
  
  const index = periodConfigs.value.findIndex(p => p.periodNumber === periodNumber);
  if (index > -1) {
    periodConfigs.value.splice(index, 1);
  }
};

const updatePeriodConfig = () => {
  // 當配置更新時觸發重新計算
  // 這裡可以加入保存到後端的邏輯
  console.log('期數配置已更新:', periodConfigs.value);
};

watch(
  [() => props.visible, () => props.studentpermissionId], 
  ([visible, id]) => {
    if (visible && id !== null && id !== undefined) {
      getAttends();
    }
  }, 
  { immediate: true }
);

async function getAttends() {
  if (!props.studentpermissionId) return;
  
  try {
    const getAttendsResult = await API.getAttends(props.studentpermissionId)
    if (getAttendsResult.data.result != 1) throw new Error(getAttendsResult.data.msg);
    rawAttendanceData.value = getAttendsResult.data.content
    console.log(rawAttendanceData.value)
  } catch (error) {
    console.error(error);
  }
}

const isShowEditDialog = ref(false);

const editForm = reactive({
  id: 0,
  studentPermissionId: 0,
  attendanceDate: '',
  attendanceType: 0,
  modifiedUserId: 51,
  isDelete: false
});

// 出勤類型選項
const attendanceTypeOptions = [
  { label: '缺席', value: 0 },
  { label: '出席', value: 1 },
  { label: '請假', value: 2 }
];

const onEdit = (row: AttendanceRecord) => {
  // 直接賦值而不是整個對象替換
  editForm.id = row.id;
  editForm.studentPermissionId = props.studentpermissionId || 0;
  editForm.attendanceDate = row.attendanceDate;
  editForm.attendanceType = row.attendanceType;
  editForm.modifiedUserId = 51;
  editForm.isDelete = false;
  
  isShowEditDialog.value = true;
};

// 刪除按鈕點擊事件
const onDelete = async (row: AttendanceRecord) => {
  try {
    const confirmResult = await ElMessageBox.confirm(
      '確定要刪除這筆出勤記錄嗎？',
      '刪除確認',
      {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      }
    );

    if (confirmResult === 'confirm') {
      const deleteData = {
        id: row.id,
        studentPermissionId: props.studentpermissionId || 0,
        attendanceDate: row.attendanceDate,
        attendanceType: row.attendanceType,
        modifiedUserId: 51,
        isDelete: true // 標記為刪除
      };
      console.log(deleteData)
      const result = await API.updateAttendance(deleteData); // 假設你的API方法名稱
      if (result.data.result === 1) {
        ElMessage.success('刪除成功');
        getAttends(); // 重新載入數據
      } else {
        throw new Error(result.data.msg);
      }
    }
  } catch (error) {
    console.error('刪除失敗:', error);
    ElMessage.error('刪除失敗');
  }
};

// 保存編輯
const saveEdit = async () => {
  try {
    console.log(editForm)
    const result = await API.updateAttendance(editForm);
    if (result.data.result === 1) {
      ElMessage.success('編輯成功');
      isShowEditDialog.value = false;
      getAttends(); // 重新載入數據
    } else {
      throw new Error(result.data.msg);
    }
  } catch (error) {
    console.error('編輯失敗:', error);
    ElMessage.error('編輯失敗');
  }
};

// 取消編輯
const cancelEdit = () => {
  isShowEditDialog.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      class: "dialog",
      "model-value": __props.visible,
      "onUpdate:modelValue": handleDialogChange,
      style: {"max-width":"1344px"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_unref(ElButton), {
                type: "primary",
                size: "small",
                onClick: addNewPeriod
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElIcon), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Plus))
                    ]),
                    _: 1
                  }),
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(periodConfigs.value, (config) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: config.periodNumber,
                  class: "config-card"
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("h4", null, "第" + _toDisplayString(config.periodNumber) + "期配置", 1),
                    _createVNode(_unref(ElButton), {
                      type: "danger",
                      size: "small",
                      onClick: ($event: any) => (removePeriod(config.periodNumber)),
                      disabled: config.periodNumber === 1
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ElIcon), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Delete))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick", "disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createVNode(_unref(ElDatePicker), {
                        modelValue: config.startDate,
                        "onUpdate:modelValue": ($event: any) => ((config.startDate) = $event),
                        type: "date",
                        size: "small",
                        format: "YYYY-MM-DD",
                        "value-format": "YYYY-MM-DD",
                        onChange: updatePeriodConfig
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createVNode(_unref(ElInputNumber), {
                        modelValue: config.totalDays,
                        "onUpdate:modelValue": ($event: any) => ((config.totalDays) = $event),
                        min: 1,
                        max: 365,
                        size: "small",
                        onChange: updatePeriodConfig
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createVNode(_unref(ElInputNumber), {
                        modelValue: config.maxAttendanceCount,
                        "onUpdate:modelValue": ($event: any) => ((config.maxAttendanceCount) = $event),
                        min: 1,
                        max: 10,
                        size: "small",
                        onChange: updatePeriodConfig
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(periods), (period) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: period.periodNumber,
                  class: _normalizeClass(["period-card", getPeriodCardClass(period)])
                }, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("h4", null, "第" + _toDisplayString(period.periodNumber) + "期", 1),
                    _createVNode(_unref(ElTag), {
                      type: getPeriodStatusType(period),
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(getPeriodStatusText(period)), 1)
                      ]),
                      _: 2
                    }, 1032, ["type"])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("span", null, _toDisplayString(formatDate(period.startDate)) + " ~ " + _toDisplayString(formatDate(period.endDate)), 1),
                      (period.hasLeaveExtension)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_21, " (因請假延期 +7天) "))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("span", null, "出席及曠課: " + _toDisplayString(period.attendanceCount), 1),
                      _createElementVNode("span", null, "請假: " + _toDisplayString(period.leaveCount), 1),
                      _createElementVNode("span", null, "剩餘: " + _toDisplayString(period.remainingCount), 1)
                    ])
                  ])
                ], 2))
              }), 128))
            ])
          ]),
          _createVNode(_unref(ElTable), {
            style: {"width":"100%"},
            data: _unref(attendanceRecords),
            border: "true",
            "header-cell-style": { backgroundColor: '#F2F2F2' },
            "empty-text": "暫無出席記錄",
            "row-class-name": getRowClassName
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElTableColumn), {
                label: "期數",
                width: "80",
                align: "center"
              }, {
                default: _withCtx(({ row }: { row: AttendanceRecord }) => [
                  _createVNode(_unref(ElTag), {
                    type: getPeriodTagType(row.periodNumber),
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.periodNumber) + "期 ", 1)
                    ]),
                    _: 2
                  }, 1032, ["type"])
                ]),
                _: 1
              }),
              _createVNode(_unref(ElTableColumn), { label: "簽到" }, {
                default: _withCtx(({ row }: { row: AttendanceRecord }) => [
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_unref(ElTag), {
                      type: getAttendanceTagType(row.attendanceType),
                      class: "attendance-tag"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.attendanceDate) + " （" + _toDisplayString(getAttendanceTypeText(row.attendanceType)) + "） ", 1)
                      ]),
                      _: 2
                    }, 1032, ["type"]),
                    _createVNode(_unref(ElTag), {
                      size: "small",
                      type: row.isTrigger ? 'info' : 'warning',
                      class: "trigger-tag"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.isTrigger ? '自動' : '人工'), 1)
                      ]),
                      _: 2
                    }, 1032, ["type"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_unref(ElTableColumn), {
                label: "期內進度",
                width: "120",
                align: "center"
              }, {
                default: _withCtx(({ row }: { row: AttendanceRecord }) => [
                  (row.attendanceType !== 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createElementVNode("span", _hoisted_25, _toDisplayString(row.periodProgress), 1),
                        _createVNode(_unref(ElProgress), {
                          percentage: (row.periodAttendanceIndex / 4) * 100,
                          "stroke-width": 6,
                          "show-text": false,
                          color: getProgressColor(row.periodAttendanceIndex),
                          style: {"margin-top":"4px"}
                        }, null, 8, ["percentage", "color"])
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_26, "請假不計入"))
                ]),
                _: 1
              }),
              _createVNode(_unref(ElTableColumn), {
                label: "期數狀態",
                width: "100",
                align: "center"
              }, {
                default: _withCtx(({ row }: { row: AttendanceRecord }) => [
                  _createVNode(_unref(ElTag), {
                    type: getPeriodRecordStatusType(row),
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(getPeriodRecordStatusText(row)), 1)
                    ]),
                    _: 2
                  }, 1032, ["type"])
                ]),
                _: 1
              }),
              _createVNode(_unref(ElTableColumn), {
                width: "170px",
                align: "center",
                prop: "operate",
                class: "operateBtnGroup d-flex",
                label: "操作"
              }, {
                default: _withCtx(({ row }: { row: AttendanceRecord }) => [
                  _createVNode(_unref(ElButton), {
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (onEdit(row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElIcon), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(EditPen))
                        ]),
                        _: 1
                      }),
                      _hoisted_27
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_unref(ElButton), {
                    type: "danger",
                    size: "small",
                    onClick: ($event: any) => (onDelete(row)),
                    style: {"margin-left":"5px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElIcon), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Delete))
                        ]),
                        _: 1
                      }),
                      _hoisted_28
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ])
      ]),
      _: 1
    }, 8, ["model-value"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowEditDialog.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isShowEditDialog).value = $event)),
      title: "編輯出勤記錄",
      width: "400px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_unref(ElButton), { onClick: cancelEdit }, {
            default: _withCtx(() => [
              _hoisted_30
            ]),
            _: 1
          }),
          _createVNode(_unref(ElButton), {
            type: "primary",
            onClick: saveEdit
          }, {
            default: _withCtx(() => [
              _hoisted_31
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: editForm,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "出勤日期" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElDatePicker), {
                  modelValue: editForm.attendanceDate,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editForm.attendanceDate) = $event)),
                  type: "date",
                  placeholder: "選擇日期",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  style: {"width":"100%"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "出勤狀態" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: editForm.attendanceType,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editForm.attendanceType) = $event)),
                  placeholder: "請選擇出勤狀態",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(attendanceTypeOptions, (option) => {
                      return _createVNode(_component_el_option, {
                        key: option.value,
                        label: option.label,
                        value: option.value
                      }, null, 8, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})